import ar from '@/i18n/translations/ar.json';
import en from '@/i18n/translations/en.json';

const translations: Record<string, any> = { ar, en };
const STORAGE_KEY = 'india-place-language';

export const getLanguage = (): 'ar' | 'en' => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return (stored === 'en' || stored === 'ar') ? stored : 'ar';
};

/**
 * Standard translation function for use outside of React components 
 * (e.g. in API interceptors)
 */
export const translate = (key: string, variables?: Record<string, any>): string => {
    const lang = getLanguage();
    const keys = key.split('.');
    let value = translations[lang];

    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            return key;
        }
    }

    if (typeof value === 'string' && variables) {
        Object.entries(variables).forEach(([k, v]) => {
            value = (value as string).replace(`{{${k}}}`, String(v));
        });
    }

    return typeof value === 'string' ? value : key;
};
